import { GET_RECOMMENDATIONS } from '../../constants/ActionTypes';

const initialState = {
  items: [],
  loading: false,
  error: null,
  loaded: false,
};

const user_recom = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_RECOMMENDATIONS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_RECOMMENDATIONS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        items: action.payload || [],
      };
    case `${GET_RECOMMENDATIONS}_FAIL`:
      return {
        ...initialState,
        loaded: true,
        loading: false,
        items: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default user_recom;
